import React from "react";

export default function BrandName() {
  return <span className="brand-wordmark">nomii</span>;
}
